import Typography from '@mui/material/Typography';
import GeneralDialog from '../../../../shared/general-dialog';
import { DIALOG_CANCEL_BUTTON_SX } from '../create-label/label-schema';

interface RenameFieldDialogProps {
  open: boolean;
  /** The field's name before this rename, shown in the title like the Google Admin console. */
  oldName: string;
  /** Puts the old name back. */
  onCancel: () => void;
  onConfirm: () => void;
}

/** Confirms renaming a live field, since the new name reaches every file it's applied to. */
export default function RenameFieldDialog({
  open,
  oldName,
  onCancel,
  onConfirm,
}: RenameFieldDialogProps) {
  return (
    <GeneralDialog
      open={open}
      handleClose={onCancel}
      title={`Rename ${oldName}?`}
      maxWidth="sm"
      dialogContent={
        <Typography variant="body2">
          Renaming this field will update all files it is currently applied to
          with the new name. The old name will no longer be visible in lists and
          removed from search results within 7-14 days.
        </Typography>
      }
      primaryButton={{
        title: 'Rename',
        action: onConfirm,
        loading: false,
        disabled: false,
        color: 'error',
      }}
      secondaryButton={{
        title: 'Cancel',
        action: onCancel,
        loading: false,
        disabled: false,
        // GeneralDialog hides the secondary button unless it's marked shown; the design has Cancel.
        shown: true,
        sx: DIALOG_CANCEL_BUTTON_SX,
      }}
    />
  );
}
